import React, { useState, useEffect, useCallback } from "react";
import Datatable from "../../../Components/Datatable"
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../../../context/AuthContext';
import Swal from 'sweetalert2'
import axios from "axios";
import { API_BASE_URL } from "../../../../../../Helpers/apiConfig";

export const AdminSectionList = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);

    const headerss = {
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + user.token
    }

    const fetchdata = useCallback(async () => {
        setLoading(true);
        try {
            let url = `${API_BASE_URL}/admin/SectionManager/GetList`; // API_BASE_URL kullanımı

            await axios({
                method: 'GET',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        const list = res.data['data'].map(item => ({
                            "id": item['id'],
                            "sectionName": item['sectionName'],
                            "sectionDescription": item['sectionDescription'],
                            "sortId": item['sortId'],
                            "isActive": item['isActive'],
                            "isDeleted": item['isDeleted'],
                            "featuredImage": item['featuredImage'],
                        }));
                        setData(list);
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err);
        }
        setLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        fetchdata();
    }, [fetchdata])

    const handleEdit = (row) => {
        window.location.href = "/admin/editsection/" + row['id'];
    }

    const updateSectionActive = async (row, newIsActive) => {
        try {
            let url = `${API_BASE_URL}/admin/SectionManager/Update`; // API_BASE_URL kullanımı
            await axios({
                method: 'Post',
                url: url,
                data: {
                    id: row['id'],
                    isDeleted: row['isDeleted'],
                    sectionName: row['sectionName'],
                    sectionDescription: row['sectionDescription'],
                    sortId: row['sortId'],
                    featuredImage: row['featuredImage'],
                    isActive: newIsActive,
                },
                headers: headerss
            }).then(async res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                        await fetchdata();
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    }

    const handleToggleActive = (row, newIsActive) => {
        Swal.fire({
            title: newIsActive ? t('confirmActivateSectionTitle') : t('confirmDeactivateSectionTitle'),
            icon: "question",
            showCancelButton: true,
            confirmButtonText: t('yes'),
            cancelButtonText: t('no'),
        }).then((result) => {
            if (result.isConfirmed) {
                updateSectionActive(row, newIsActive);
            }
        });
    }

    const activeColumns = React.useMemo(
        () => [
            {
                Header: t('sectionName'),
                Footer: t('sectionName'),
                accessor: 'sectionName',
            },
            {
                Header: t('sectionDescription'),
                Footer: t('sectionDescription'),
                accessor: 'sectionDescription',
            },
            {
                Header: t('sortid'),
                Footer: t('sortid'),
                accessor: 'sortId',
            },
            {
                Header: t('deactivateSection'),
                accessor: (originalRow) => (
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={() => handleToggleActive(originalRow, false)}
                        >
                            {t('deactivateSection')}
                        </button>
                    </div>
                ),
                id: 'actionDeactivate',
                Footer: t('deactivateSection'),
            },
            {
                Header: t('editSection'),
                accessor: (originalRow) => (
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t('edit')}
                        </button>
                    </div>
                ),
                id: 'actionEditCourse',
                Footer: t('editSection'),
            },
        ],
        [],
    )

    const passiveColumns = React.useMemo(
        () => [
            {
                Header: t('sectionName'),
                Footer: t('sectionName'),
                accessor: 'sectionName',
            },
            {
                Header: t('sectionDescription'),
                Footer: t('sectionDescription'),
                accessor: 'sectionDescription',
            },
            {
                Header: t('sortid'),
                Footer: t('sortid'),
                accessor: 'sortId',
            },
            {
                Header: t('activateSection'),
                accessor: (originalRow) => (
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-success btn-sm"
                            onClick={() => handleToggleActive(originalRow, true)}
                        >
                            {t('activateSection')}
                        </button>
                    </div>
                ),
                id: 'actionActivate',
                Footer: t('activateSection'),
            },
            {
                Header: t('editSection'),
                accessor: (originalRow) => (
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t('edit')}
                        </button>
                    </div>
                ),
                id: 'actionEditCourse',
                Footer: t('editSection'),
            },
        ],
        [],
    )

    const activeData = data.filter(row => row.isActive);
    const passiveData = data.filter(row => !row.isActive);

    return (
        <div style={{ backgroundColor: "white", width: "full" }} >
            <div style={{ textAlign: "center" }}>
                <h3>{msg}</h3>
                <h1>{t("sectionList")}</h1>
                {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loading && (
                    <div>
                        <h2>{t("activeSections")}</h2>
                        <Datatable data={activeData} columns={activeColumns} tableBaslik={t("activeSections")} />
                        <h2>{t("passiveSections")}</h2>
                        <Datatable data={passiveData} columns={passiveColumns} tableBaslik={t("passiveSections")} />
                    </div>
                )}
            </div>
        </div>
    );
};
export default AdminSectionList;
